export const version = "1.10.6";